import React, {
  useState,
  useLayoutEffect,
  useContext,
  useRef,
} from "react";
import { useStaticQuery, graphql } from 'gatsby'

import styled, { ThemeProvider } from "styled-components";
import AOS from "aos";
import Script from 'react-load-script';

import Header from "../Header";
import Footer from "../Footer";
import SEO from '../SEO'

import GlobalContext from "../../context/GlobalContext";

import GlobalStyle from "../../utils/globalStyle";

import "../../assets/fonts/fontawesome-5/webfonts/fa-brands-400.ttf";
import "../../assets/fonts/fontawesome-5/webfonts/fa-regular-400.ttf";
import "../../assets/fonts/fontawesome-5/webfonts/fa-solid-900.ttf";

import "../../assets/fonts/typography-font/CircularStd-Bold.ttf";
import "../../assets/fonts/typography-font/CircularStd-BoldItalic.ttf";
import "../../assets/fonts/typography-font/CircularStd-Book.ttf";
import "../../assets/fonts/typography-font/CircularStd-BookItalic.ttf";
import "../../assets/fonts/typography-font/CircularStd-Medium.ttf";


import "../../../node_modules/aos/dist/aos.css";

import "../../assets/fonts/typography-font/typo.css";
import "../../assets/fonts/fontawesome-5/css/all.css";

import "../../scss/bootstrap.scss";
import "../../scss/main.scss";

import { get, merge } from "lodash";

// the full theme object
import { theme as baseTheme } from "../../utils";

const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999999999;
  opacity: 1;
  visibility: visible;
  transition: all 1s ease-out 0.5s;
  &.inActive {
    opacity: 0;
    visibility: hidden;
  }
`;

// options for different color modes
const modes = { light: "light", dark: "dark" };

// merge the color mode with the base theme
// to create a new theme object
const getTheme = (mode) =>
  merge({}, baseTheme, {
    colors: get(baseTheme.colors.modes, mode, baseTheme.colors),
  });

const Layout = ({ children, pageContext }) => {
  const gContext = useContext(GlobalContext);

  const [visibleLoader, setVisibleLoader] = useState(true);

  useLayoutEffect(() => {
    AOS.init({ once: true });
    setVisibleLoader(false);
  }, []);

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultTitle: title
          defaultDescription: description
          defaultImage: image
        }
      }
    }
  `)

  const {
    defaultTitle,
    defaultDescription,
    defaultImage
  } = data.site.siteMetadata

  // Navbar style based on scroll
  const eleRef = useRef();

  if (pageContext.layout === "bare") {
    return (
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
      >
        <div data-theme-mode-panel-active data-theme="light">
          <GlobalStyle />
          <SEO
            title={defaultTitle}
            description={defaultDescription}
            imageUrl={defaultImage}
            relativePath=""
            sharingTitle={defaultTitle}
          />
          <Loader id="loading" className={visibleLoader ? "" : "inActive"}>
            <div className="load-circle">
              <span className="one"></span>
            </div>
          </Loader>
          <div className="site-wrapper overflow-hidden" ref={eleRef}>
            {children}
            <Footer isDark={gContext.footerDark} />
          </div>
        </div>
        <Script
          url="https://widgets.instantdemo.co/widget-init.js"
          attributes={{
            'data-id': 'instant-demo-init-script',
            'data-token': 'ex2glt2lmmo4wctaxl2vp62k9oa8a3xyr33mno86',
            'async': true
          }}
        />
      </ThemeProvider>
    );
  }

  return (
    <>
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
      >
        <div data-theme-mode-panel-active data-theme="light">
          <GlobalStyle />
          <SEO
            title={defaultTitle}
            description={defaultDescription}
            imageUrl={defaultImage}
            relativePath=""
            sharingTitle={defaultTitle}
          />
          <Loader id="loading" className={visibleLoader ? "" : "inActive"} />
          <div className="site-wrapper overflow-hidden" ref={eleRef}>
            <Header isDark={gContext.headerDark} />
            {children}

            <Footer isDark={gContext.footerDark} />
          </div>
        </div>
        <Script
          url="https://widgets.instantdemo.co/widget-init.js"
          attributes={{
            'data-id': 'instant-demo-init-script',
            'data-token': 'ex2glt2lmmo4wctaxl2vp62k9oa8a3xyr33mno86',
            'async': true
          }}
        />
      </ThemeProvider>
    </>
  );
};

export default Layout;
